import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { lower } from 'change-case'
import { Form, reduxForm, getFormValues } from 'redux-form'
import { Field } from 'redux-form'
import { Button } from 'semantic-ui-react'
import FieldInput, { InputType as type } from 'components/SemanticForm'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import { validations, validateCase as vCase } from 'core/validate'
import { CancelGRContainer } from './styled'
import { getHrmsMembers, getAllMembers } from 'ducks/member'
import { cancelGr } from 'ducks/support'

// import r from 'reactotron-react-js'

const CancelGR = (props) => {
  const { members, memberLoading, reset } = props

  useEffect(() => {
    if (!members.length) {
      props.getAllMembers()
      // props.getHrmsMembers()
    }
  }, [])

  const memberOptions = members.map(m => ({ value: lower(m.username), text: `${m.firstnameEn} ${m.lastnameEn}` }))

  return (
    <CancelGRContainer>
      <Form>
        <div className='rowFields'>
          <Field 
            name='docNumber' 
            label='GR Document Number' 
            type={type.text}
            component={FieldInput} />
          <Field 
            name='requester' 
            label='Requester (User request cancel document)' 
            loading={memberLoading}
            options={memberOptions} 
            type={type.select}
            component={FieldInput} />
        </div>
        <div className='rowFields'>
          <Field 
            name='reason' 
            label='Reason' 
            type={type.textArea}
            component={FieldInput} />
        </div>
        <div className='btnContainer'>
          <Button
            type='button'
            content='Submit'
            color='blue'
            icon='paper plane outline'
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={() => props.cancelGr(props.valueForm, reset)}
          />
        </div>
      </Form>
    </CancelGRContainer>
  )
}

const mapStateToProps = (state) => {
  return ({
    user: state.authen.user,
    members: state.member.members,
    memberLoading: state.member.memberLoading,
    valueForm: getFormValues('cancelGrForm')(state) || {},
  })
}

const mapDispatchToProps = {
  getHrmsMembers,
  cancelGr,
  getAllMembers
}

const validate = (values) => {
  let errors = {}
  validations(values, 'docNumber', [vCase.require], errors)
  validations(values, 'requester', [vCase.require], errors)
  validations(values, 'reason', [vCase.require], errors)

  return errors
}

const CancelGRForm = reduxForm({
  form: 'cancelGrForm',
  enableReinitialize: true,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(CancelGR)

export default connect(mapStateToProps, mapDispatchToProps)(CancelGRForm)